module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_M_2.c68d793d.mp3";